

export const Footer = () => {
  return (
    <>
       <div className="container newsletter mt-5 wow fadeIn" data-wow-delay="0.1s">
  <div className="row justify-content-center">
    <div className="col-lg-10 border rounded p-1">
      <div className="border rounded text-center p-1">
        <div className="bg-white rounded text-center p-5">
          <h4 className="mb-4">
            Subscribe Our{" "}
            <span className="text-warning text-uppercase">Newsletter</span>
          </h4>
          <div className="position-relative mx-auto" style={{ maxWidth: 400 }}>
            <input
              className="form-control w-100 py-3 ps-4 pe-5"
              type="text"
              placeholder="Enter your email"
            />
            <button
              type="button"
              className="btn btn-warning py-2 px-3 position-absolute top-0 end-0 mt-2 me-2"
            >
              Submit
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>



       <div
  className="container-fluid bg-dark text-light footer wow fadeIn"
  data-wow-delay="0.1s"
>
  <div className="container pb-5">
    <div className="row g-5">
      <div className="col-md-6 col-lg-4">
        <div className="bg-warning rounded p-4">
          <a href="index.html">
            <h1 className="text-white text-uppercase mb-3">Hotelier</h1>
          </a>
          <p className="text-white mb-0">
            Download{" "}
            <a
              className="text-dark fw-medium"
              href="https://htmlcodex.com/hotel-html-template-pro"
            >
              Hotelier – Premium Version
            </a>
            , build a professional website for your hotel business and grab the
            attention of new visitors upon your site’s launch.
          </p>
        </div>
      </div>
      <div className="col-md-6 col-lg-3">
        <h6 className="section-title text-start text-warning text-uppercase mb-4">
          Contact
        </h6>
        <p className="mb-2">
          <i className="fa fa-map-marker-alt me-3" />
          123 Street, New York, USA
        </p>
        <p className="mb-2">
          <i className="fa fa-phone-alt me-3" />
          +012 345 67890
        </p>
        <p className="mb-2">
          <i className="fa fa-envelope me-3" />
          info@example.com
        </p>
        <div className="d-flex pt-2 ">
          <button className="btn btn-outline-light btn-social"  style={{borderRadius: "24px"}}>
            <i className="fab fa-twitter" />
          </button>
          <button className="btn btn-outline-light btn-social mx-2"  style={{borderRadius: "24px"}}>
            <i className="fab fa-facebook-f" />
          </button>
          <button className="btn btn-outline-light btn-social"  style={{borderRadius: "24px"}}>
            <i className="fab fa-youtube" />
          </button>
          <button className="btn btn-outline-light btn-social mx-2"  style={{borderRadius: "24px"}}>
            <i className="fab fa-linkedin-in" />
          </button>
        </div>
      </div>
      <div className="col-lg-5 col-md-12">
        <div className="row gy-5 g-4">
          <div className="col-md-6">
            <h6 className="section-title text-start text-warning text-uppercase mb-4">
              Company
            </h6>
            <button className="btn btn-link" type="button">
              About Us
            </button>
            <button className="btn btn-link" type="button">
              Contact Us
            </button>
            <button className="btn btn-link" type="button">
              Privacy Policy
            </button>
            <button className="btn btn-link" type="button">
              Terms &amp; Condition
            </button>
            <button className="btn btn-link" type="button">
              Support
            </button>
          </div>
          <div className="col-md-6">
            <h6 className="section-title text-start text-warning text-uppercase mb-4">
              Services
            </h6>
            <button className="btn btn-link" type="button">
              Food &amp; Restaurant
            </button>
            <button className="btn btn-link" type="button">
              Spa &amp; Fitness
            </button>
            <button className="btn btn-link" type="button">
              Sports &amp; Gaming
            </button>
            <button className="btn btn-link" type="button">
              Event &amp; Party
            </button>
            <button className="btn btn-link" type="button">
              GYM &amp; Yoga
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div className="container">
    <div className="copyright">
      <div className="row">
        <div className="col-md-6 text-center text-md-start mb-3 mb-md-0">
          ©{" "}
          <a className="border-bottom" href="/">
            Your Site Name
          </a>
          , All Right Reserved.
          {/*/*** This template is free as long as you keep the footer author’s credit link/attribution link/backlink. If you'd like to use the template without the footer author’s credit link/attribution link/backlink, you can purchase the Credit Removal License from "https://htmlcodex.com/credit-removal". Thank you for your support. *** /*/}
          Designed By{" "}
          <a className="border-bottom" href="https://htmlcodex.com">
            HTML Codex
          </a>
        </div>
        <div className="col-md-6 text-center text-md-end">
          <div className="footer-menu">
            <a href="/">Home</a>
            <a href="/">Cookies</a>
            <a href="/">Help</a>
            <a href="/">FQAs</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>


    
    </>
  )
}
